import { type AppRouter, initClient } from '@ts-rest/core'
import { useMemo } from 'react'
import { config } from '@/config'
import { useSession } from '@/providers/session'

export const buildFlightDeckTsRestClient = <T extends AppRouter>(contract: T, getToken: () => Promise<string | null>) =>
  initClient(contract, {
    baseUrl: config.VITE_FLIGHT_DECK_API_URL.replace(/\/flight-deck\/?$/, ''),
    baseHeaders: {},
    jsonQuery: true,
    throwOnUnknownStatus: true,
    api: async args => {
      const token = await getToken()
      const response = await fetch(args.path, {
        method: args.method,
        headers: {
          ...args.headers,
          'Content-Type': 'application/json',
          Authorization: token ? `Bearer ${token}` : '',
        },
        body: args.body,
        credentials: 'include',
        /**
         * keepalive is necessary for ensuring requests finish post broadcast window reloadF
         */
        ...args.fetchOptions,
      })
      const body = await response.json().catch(() => undefined)
      return {
        status: response.status,
        body,
        headers: response.headers,
      }
    },
  })

export const useFlightDeckTsRestClient = <T extends AppRouter>(contract: T) => {
  const { getToken } = useSession()
  return useMemo(() => buildFlightDeckTsRestClient(contract, getToken), [contract, getToken])
}
